import { z } from 'zod';
import { EthnicityOptions } from '@govinity/shared-config';
import { addressOptionalSchema } from '../addresses/index.js';
import { phoneOptionalSchema } from '../phones/index.js';
// Create validation and DTO type
export const meetingMemberCreateSchema = z.object({
    firstName: z
        .string('First name is required')
        .min(1, 'First name is required')
        .describe('Required for create'),
    lastName: z
        .string('Last name is required')
        .min(1, 'Last name is required')
        .describe('Required for create'),
    email: z.email('Invalid email address').nullable().optional(),
    avatarUrl: z.url('Invalid avatar URL').nullable().optional(),
    phone: phoneOptionalSchema.nullable().optional(),
    website: z.url('Invalid website URL').nullable().optional(),
    employer: z.string().trim().nullish(),
    occupation: z.string().trim().nullish(),
    ethnicity: z.enum(EthnicityOptions).nullish(),
    notes: z.string().nullable().optional(),
    address: addressOptionalSchema.nullable().optional(),
    userId: z.number().nullish().describe('Link to an existing platform user ID'),
});
// Bulk create validation and DTO type
export const meetingMemberBulkCreateSchema = z
    .array(meetingMemberCreateSchema)
    .min(1, 'Meeting members array is required and must not be empty');
// Update validation and DTO type
export const meetingMemberUpdateSchema = meetingMemberCreateSchema.partial();
/**
 * Search filters for meeting members. When `meetingBodyIds` is provided, results are scoped to
 * members holding a current-term seat assignment on one of those bodies; `activeOnly` further
 * narrows to assignments with an `active` status (mirroring the board-message recipient rule).
 */
export const searchMeetingMembersSchema = z.object({
    meetingBodyIds: z.array(z.number()).optional(),
    activeOnly: z.boolean().optional(),
});
